import { Record } from 'immutable';
import { PartyType } from './party-type';

const ContactRecord = Record({
  eventContactId: 0,
  version: 0,
  createDate: null,
  modifiedDate: null,
  partyType: null,
  eventId: null,
  firstName: null,
  lastName: null,
  email: null,
  phone: null,
  fax: null
});

export class Contact extends ContactRecord {
  eventContactId: number;
  version: number;
  createdDate: Date;
  modifiedDate: Date;
  partyType: PartyType;
  eventId: number;
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  fax: number;
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/models/contact.ts